import React from 'react';
import { createPortal } from 'react-dom';
import ContentLoader from 'react-content-loader';
import { rootHeaderTopBar as rootContainer } from '../../roots';

const defaultProps = {
	speed: 1.2,
	interval: 0.25,
	backgroundColor: '#f5f6f7',
	foregroundColor: '#eee',
	title: 'Loading...',
};

const NavigationLoader = () => (
	<ContentLoader {...defaultProps} height={60} viewBox="0 0 1200 60">
		<rect x="100" y="18" width="80" height="18" rx="3" />
		<rect x="220" y="18" width="80" height="18" rx="3" />
		<rect x="340" y="18" width="80" height="18" rx="3" />
		<rect x="460" y="18" width="80" height="18" rx="3" />
		<rect x="580" y="18" width="80" height="18" rx="3" />
		<rect x="700" y="18" width="80" height="18" rx="3" />
		<rect x="820" y="18" width="80" height="18" rx="3" />
		<rect x="930" y="18" width="80" height="18" rx="3" />
		<circle cx="36" cy="25" r="25" />
	</ContentLoader>
);

const TopBarLoader = () => (
	<ContentLoader
		{...defaultProps}
		width={100}
		height={50}
		viewBox="0 0 360 50"
		style={{ width: '100%' }}
	>
		<rect x="30" y="8" width="360" height="30" rx="3" />
	</ContentLoader>
);

export function Loading() {
	const topBarContainer = document.querySelector(rootContainer);

	if (!topBarContainer) {
		return null;
	}

	// const topBarRoot = createRoot(topBarContainer);

	return createPortal(
		<>
			<TopBarLoader />
			<NavigationLoader />
		</>,
		topBarContainer,
	);
}
